export class FichaParams {
    public id?:number
    public fic_id?: number
    public creado?: string
    public content?: any
}
